import ChevronRight from './chevron-right';
import ChevronLeft from './chevron-left';

import {buildHandleEnterKeyPress} from '../utils/accessibility';

export function Previous({disabled, onClick}: {disabled: boolean; onClick: (() => void) | undefined}) {
  return (
    <ChevronLeft disabled={disabled} onClick={onClick} onKeyPress={buildHandleEnterKeyPress(onClick)} tabIndex={0} />
  );
}

export function Next({disabled, onClick}: {disabled: boolean; onClick: (() => void) | undefined}) {
  return (
    <ChevronRight disabled={disabled} onClick={onClick} onKeyPress={buildHandleEnterKeyPress(onClick)} tabIndex={0} />
  );
}
